import { Color } from "../enums/Color"

export const commonHeader = {
    mobile: {
        row: {
            display: "flex",
            flexDirection: "row" as "row",
            position: "relative"
        },
        desktopImageLeft: {
            display: "none",
            position: "absolute" as "absolute",
            height: "65%",
            bottom: "0",
            left: "0",
            transform: "translate(-40%, 0)"
        },
        longBuildingSvg: {
            position: "absolute" as "absolute",
            right: "0",
            bottom: "0",
            width: "95%"
        },
        startCurve: {
            display: "none",
            position: "absolute" as "absolute",
            top: "-9.8vw",
            width: "62vw",
            height: "25.88vw"
        },
        endCurve: {
            display: "none",
            position: "absolute" as "absolute",
            top: "-4.5vw",
            width: " 71.82vw",
            height: "25.88vw"
        },
        backButton: {
            wrapper: {
                display: "block",
                position: "absolute" as "absolute",
                top: "18.42vw",
                left: "6.28vw",
                alignItems: "center",
                zIndex: "1",
                cursor: "pointer",
                WebkitTapHighlightColor: "transparent"
            },
            button: {
                width: "6.7vw",
                height: "6.7vw",
                backgroundColor: Color.White,
                boxShadow: "0px 0px 0px 1.45vw rgb(255 255 255 / 0.35)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0"
            },
            icon: {
                fill: Color.DeepBlack,
                width: "2.41vw"
            },
            text: {
                display: "none",
                marginLeft: "0.78vw",
                fontSize: "0.93vw",
                fontWeight: "bold",
                color: Color.White
            }
        },
        title: {
            margin: "4.83vw 0 0 4.83vw",
            cursor: "pointer",
            width: "39.37vw",
            height: "9.18vw"
        },
        label: {
            textDecoration: "none",
            fontSize: "4.34vw",
            fontWeight: "bold" as "bold",
            letterSpacing: "0px",
            color: Color.LightAsh,
            opacity: "1",
            cursor: "pointer",
            hover: {
                borderBottom: "2px solid " + Color.DarkAsh
            }
        },
        dropdownLabel: {
            position: "relative" as "relative",
            textDecoration: "none",
            fontSize: "4.4vw",
            fontWeight: "medium",
            letterSpacing: "0px",
            color: Color.MiddleBlack,
            cursor: "pointer",
            opacity: "1"
        },        
        storeIcon: {
            width: "4.2vw",
            height: "4.2vw",
            paddingTop: "1vw",
            marginLeft: "0"
        },
        storeLabel: {
            fontSize: "4.34vw"
        },
        dropdownItem: {
            color: Color.MiddleBlack,
            fontWeight: "500",
            hover: {
                backgroundColor: Color.Blue,
                padding: "1.38vw",
                borderRadius: "1.94vw",
                color: Color.White
            },
            leave: {
                backgroundColor: Color.White,
                padding: "1.38vw"
            }
        },
        desktopMenu: {
            explore: {
                hover: {
                    width: "11.2vw"
                }
            },
            store: {
                hover: {
                    width: "8.8vw"
                }
            },
            storeButton: {
                hover: {
                    width: "8.8vw"
                }
            }
        },
        loginWrapper: {
            display: "contents"
        },
        mobileMenuButton: {
            backgroundColor: "transparent",
            border: "none",
            margin: "5.2vw 4.83vw 0 auto",
            padding: "unset"
        },
        profileWrapper: {
            display: "none"
        }
    },
    desktop: {
        longBuildingSvg: {
            display: "block",
            width: "unset",
            height: "98%"
        },
        desktopImageLeft: {
            display: "block"
        },
        mobileImage: {
            display: "none"
        },
        startCurve: {
            display: "block"
        },
        endCurve: {
            display: "block"
        },
        backButton: {
            wrapper: {
                display: "flex",
                top: "6.7vw",
                left: "7.6vw"
            },
            button: {
                width: "2.6vw",
                height: "2.6vw",
                boxShadow: "0px 0px 0px 0.5vw rgb(255 255 255 / 0.35)"
            },
            icon: {
                width: "0.78vw"
            },
            text: {
                display: "block",
                marginLeft: "1.2vw"
            }
        },
        title: {
            margin: "2.08vw 0 0 2.70vw",
            width: "15.52vw",
            height: "3.65vw"  
        },
        label: {
            fontSize: "0.937vw"
        },
        dropdownLabel: {
            fontSize: "0.937vw"
        },
        dropdownItem: {
            fontSize: "0.83vw",         
            hover: {
                borderRadius: "0.36vw",
                padding: "0.31vw 0.52vw"
            },
            leave: {
                padding: "0.31vw 0.52vw"
            }
        },
        storeContainer: {
            display: "flex", 
            flexDirection: "row",
            justifyContent: "center", 
            alignItems: "center"
        },
        storeIcon: {
            width: "1.19vw",
            height: "1.19vw",
            paddingTop: "0"
        },
        storeLabel: {
           marginLeft: "0.52vw",
           fontSize: "1.04vw",
           marginRight: "0.1vw"
        },
        desktopMenu: {
            storeButton: {
                button: {
                    height: "3.64vw",
                    width: "11.09vw",
                    backgroundColor: Color.DeepBlack,   
                    display: "flex", 
                    justifyContent: "center", 
                    alignItems: "center",
                    marginTop: "-1vw",
                    borderRadius: "0.52vw"
                },
                hover: {
                    marginTop: "1vw",
                    width: "10vw"
                }
            }
        },        
        mobileMenuButton: {
            display: "none"
        },
        profileWrapper: {
            display: "flex",
            marginTop: "3vh",
            marginRight: "1.5vw"
        }
    }
}
